<script>
  let y = 0;
  $: padding = y > 500 ? Math.min(Math.floor((y - 500) / 8), 72) : 0
  //$: right_top = y > 500 ? Math.max(Math.floor((500 - y) / 6), -700) : 0
  let right_top = 0
</script>

<svelte:window bind:scrollY={y} />

<div class="news-section clear" id="maincontent">
  <div class="inner">	
    <div class="right-50 news-section-right" style="background-color: white; position: relative; top: {right_top}px;">
      <div class="blog-item">
        <div class="blog-item-in" data-wow-delay=".5s" style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInUpS;">
          <div class="sub-title">News</div>
          <h3>The Sunvair Group Exhibiting at 53rd International Paris Air Show</h3>
          <a class="read-more dark" href="/the-sunvair-group-exhibiting-at-53rd-international-paris-air-show/">READ MORE<span class="screen-reader-text">The Sunvair Group Exhibiting at 53rd International Paris Air Show</span></a>
        </div>
      </div>
      <div class="blog-item">
        <div class="blog-item-in  wow fadeInDownS" data-wow-delay=".5s" style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInDownS;">
          <div class="sub-title">Events</div>
          <h3>The Sunvair Group's 2020 Trade Show Exhibition Calendar</h3>
          <a class="read-more dark" href="/trade-show-exhibition-calendar/">READ MORE<span class="screen-reader-text">The Sunvair Group's 2020 Trade Show Exhibition Calendar</span></a>
        </div>
      </div>
    </div>
    <div class="left-50 news-section-left" style="padding-top: {padding}px;">
      <img src="/img/gear-detail.jpg" class="attachment-full size-full" alt="AH-64 Apache Helicopter" xstyle="padding-top: 71px;" width="630" height="694">
    </div>
  </div>
</div>
